import { ICON_SIZE } from '@yme/atoms/svg-icon';
import { buildStateParam } from '@yme/utils/common';
import { SpinnerLoaderSizes } from './types';
export const getSpinnerLoaderSize = (size) => {
    switch (size) {
        case SpinnerLoaderSizes.LARGE:
            return ICON_SIZE.m;
        case SpinnerLoaderSizes.SMALL:
            return ICON_SIZE.s;
        default:
            return ICON_SIZE.m;
    }
};
export const getId = (id) => id || buildStateParam();
